// removed by extract-text-webpack-plugin
module.exports = {"overlay":"G69a9d2 G316e3b","overlayText":"Gcadaff"};